module.exports = __webpack_public_path__ + "static/media/comp-cooling-s.7aa89767.jpg";